import React, { Component } from 'react';
import '../App.css';
import Sidemenu from '../components/Sidemenu';
import TopNav1 from '../components/TopNav1';
import { getUserData, PostData, GetData, urls } from "../common";
import Spinner from '../Spinner.js';
import history from '../history';
import $ from "jquery";
import moment from 'moment';
import Modals from './Modals.js';

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdmin: false,
      user: {},
      profilePic: '',
      loggedin: false,
      loginMsg: "",
      loginLoading: false,
      mobile: "",
      password: "",
      userPoints: "",
      position: "",
      userSpins: "",
      playlist: [],
      buySelection: {},
      purchaseMsg: "",
      selectednetwork: "",
      purchaseLoading: false
    };
  }
  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    var user = await getUserData();

    if (user !== undefined || user !== null) {
      this.setState({ user: user, loggedin: true });

      // var userPoints = await GetData(urls.points);
      // if (userPoints.code === 200) {
      //   this.setState({ userPoints: userPoints.message });
      // }

    }
  };

  render() {
    const { loginMsg, loginLoading, userPoints, position, userSpins, playlist,
      purchaseMsg, purchaseLoading } = this.state;
    
    return (
      <div id="wrapper">

        <Sidemenu />
        {/* End of Sidebar */}

        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">

          {/* Main Content */}
          <div id="content">

            <TopNav1 />

            {/* Leader board / notices */}
            <div className="container">
              <div className="row grey-border b-pa  ">
                <div className="col-sm r-line d-none d-sm-block d-md-none">
                  <img className="img-fluid  mt-3 howitworks" style={{ width: "9rem" }} src="img/rocket.png" alt="..." />
                </div>

                <div className="col-sm r-line score-tip  ">
                  <div className="score-bg">
                    <h6 className="m-0 font-weight-bold text-primary">IOS</h6>
                  </div>
                  <div className="col-sm r-line">
                    <a href=""><img className="img-fluid  mt-3  howitworks" style={{ width: "25rem" }} src="img/ios.png" alt="..." /></a>
                    <br/>
                    <small>Download the IOS version from the appstore </small>
                  </div>

                </div>

                <div className="col-sm r-line ">
                  <div className="card-header score-bg">
                    <h6 className="m-0 font-weight-bold text-primary">Android</h6>
                  </div>

                  <div className="col-sm r-line">
                    <a href=""><img className="img-fluid  mt-3  howitworks" style={{ width: "25rem" }} src="img/playstore.png" alt="..." /></a>
                    <br/>
                    <small>Download the Android version </small>
                  </div>


                </div>

              </div>
            </div>
            {/* leader board / notices end */}

            <div className="container"><hr /></div>

            {/* Footer */}
            <footer className="sticky-footer bg-white">
              <div className="container my-auto">
                <div className="copyright text-center my-auto">
                  <span>Copyright &copy; nCartaBox {moment().format("YYYY")}</span>
                </div>
              </div>
            </footer>
            {/* End of Footer */}

          </div>
          {/* End of Content Wrapper */}
        <Modals/>
        </div>
        {/* End of Page Wrapper */}

        {/* Scroll to Top Button*/}
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>

      </div>
    );
  }
}
